<template>
  <div class="bto-sb-widget bto-sb-widget-category bto-sb-category-print">
    <div class="bto-sb-widget bto-sb-widget-prematch">
      <div class="bto-sb-widget-title bto-sb-widget-nav-icon">
        <h3>{{t('StatusTipePrint.OddTypes')}}</h3>
        <ul class="bto-sb-widget-nav-icon">
          <li>
            <span class="bto-sb-category-print-all">
              <label class="bto-sb-form-switch">
                <input type="checkbox" @change="toggleSelectAll($event)">
                <span class="bto-sb-form-switch-slider"></span>
              </label>
              <label>{{t('Global.SelectAll')}}</label>
            </span>
          </li>
          <li>
            <a :title="t('Public.Close')" class="bto-sb-widget-nav-icon-close" @click="closeCategoryPrintPage()"></a>
          </li>
        </ul>
      </div>
      <div class="bto-sb-widget-content">
        <div class="bto-sb-category-print-row bto-sb-category-print-nav">
          <div
            class="bto-sb-category-print-col"
            v-for="(mainMarket, idx) in mainMarkets"
            :key="idx">
            <label class="bto-sb-form-control bto-sb-form-control-checkbox">
              {{mainMarket.marketName}}
              <input type="checkbox" v-model="mainMarket.selected">
              <span class="bto-sb-form-control-indicator"></span>
            </label>
          </div>
        </div>
        <div
          class="bto-sb-category-print-row"
          v-for="rowIdx in Math.ceil(allMarketsCombined.length / 4)"
          :key="rowIdx">
            <div
              class="bto-sb-category-print-col"
              v-for="colIdx in 4"
              :key="colIdx">
              <label class="bto-sb-form-control bto-sb-form-control-checkbox"
                  :title="allMarketsCombined[rowIdx + colIdx + rowIdx * 3].marketName"
                  v-if="allMarketsCombined[rowIdx + colIdx + rowIdx * 3]">
                {{allMarketsCombined[rowIdx + colIdx + rowIdx * 3].marketName}}
                <input type="checkbox" v-model="allMarketsCombined[rowIdx + colIdx + rowIdx * 3].selected">
                <span class="bto-sb-form-control-indicator"></span>
              </label>
            </div>
          </div>
          <div class="bto-sb-category-print-row bto-sb-category-print-control">
            <div class="bto-sb-category-print-col">
              <h4>{{t('StatusTipePrint.PageLayout')}}</h4>
              <div class="bto-sb-form-select">
                <select v-model="layoutSetting">
                  <option :value="0">{{t('StatusTipePrint.PageLayout.Horizontal')}}</option>
                  <option :value="1">{{t('StatusTipePrint.PageLayout.Vertical')}}</option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
            <div class="bto-sb-category-print-col">
              <h4>{{t('StatusTipePrint.FontSize')}}</h4>
              <div class="bto-sb-form-select">
                <select v-model="fontSizeSetting">
                  <option :value="0">{{t('StatusTipePrint.FontSize.Normal')}}</option>
                  <option :value="1">{{t('StatusTipePrint.FontSize.Large')}}</option>
                </select>
                <div class="bto-sb-form-select-arrow"></div>
              </div>
            </div>
          </div>
          <div class="bto-sb-category-print-footer">
            <a style="opacity: 0;" download="odds.xls" id="excelDownloadElement"></a>
            <a class="bto-sb-form-btn"
              :class="{'loading-cursor': this.loadingCursor}"
              :title="`${this.loadingCursor ? t('W.load') : t('W.downloadE')}`"
              @click="downloadExcel($event)">
              {{t('StatusTipePrint.Excel')}}
            </a>
            <a class="bto-sb-form-btn" @click="printData($event)">
              {{t('Public.Print')}}
            </a>
            <a class="bto-sb-form-btn" @click="closeCategoryPrintPage()">
              {{t('Public.Close')}}
            </a>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CategoryPrintPage from './category-print-page';
  import store from '../../../store';

  import { EventBus } from '../../../services/event-bus-service';
  import { chunkArray } from '../../../services/utils';
  import { PrintOddsRequestService } from './service-print-odds';

  import CategoryPrintMixin from './category-print-mixin';

  export default {
    name: 'CategoryPrintComponent',
    props: {
      tournamentData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        mainMarkets: [],
        allMarketsCombined: [],
      };
    },
    mixins: [CategoryPrintMixin],
    created() {
      this.mainMarkets = this.tournamentData.matches[0].odds.map(o => ({
        marketId: o.marketId,
        marketName: o.marketName,
        selected: true,
      }));

      const mainMarketsMap = this.mainMarkets.reduce((acc, val) => {
        acc[val.marketId] = true;
        return acc;
      }, {});

      const allMarkets = store.getters.getSportMarkets(this.tournamentData.sportId);
      this.allMarketsCombined = allMarkets.flatMap(m => m.tabs.filter(t => !mainMarketsMap[t.id])
        .map(t => ({
          marketId: Number.parseInt(t.id, 10),
          marketName: t.name,
          selected: false,
        })));
    },
    methods: {
      closeCategoryPrintPage() {
        EventBus.$emit('closeCategoryPrintPage');
      },
      toggleSelectAll(event) {
        let toggleValue = event.target.checked;

        this.mainMarkets.forEach(m => m.selected = toggleValue);
        this.allMarketsCombined.forEach(m => m.selected = toggleValue);
      },
      getSelectedMarkets() {
        return this.mainMarkets.concat(this.allMarketsCombined).filter(m => m.selected).map(m => m.marketId);
      },
      async generatePrintPage() {
        let printOddsRequest = new PrintOddsRequestService();

        printOddsRequest.postParams.oddTypeIDs = this.getSelectedMarkets();

        return new Promise((resolve, reject) => {
          // we have no markets selected stop print
          if (!printOddsRequest.postParams.oddTypeIDs.length) {
            reject('(print) no markets selected');
            return;
          }

          if (this.tournamentData.isGroup) {
            printOddsRequest.postParams.TournamentGroupData = [this.tournamentData.id];
          } else {
            printOddsRequest.postParams.TournamentData = [this.tournamentData.id];
          }

          printOddsRequest.execute((response) => {
            let tournamentId = this.tournamentData.id;
            // no data recived from api stop print
            if (!response.data || !response.data.o) {
              reject('(print) no data');
              return;
            }

            let headers = response.data.h;
            let matchOutcomes = {};
            if (Object.keys(response.data.o).length > 1 || this.tournamentData.isGroup) {
              for (let key in response.data.o) {
                matchOutcomes = Object.assign(matchOutcomes, response.data.o[key]);
              }
            } else {
              matchOutcomes = response.data.o[tournamentId];
            }

            let flatHeaders = [];
            // map table headers array
            Object.entries(headers).forEach(([oddId_outcomeId, positionAndOutcomeName]) => {
              let parts = oddId_outcomeId.split('_');
              let oddId = parts[0];
              let outcomeId = parts[1];

              let originalOdd = this.mainMarkets.find(m => m.marketId == oddId)
                ||
                this.allMarketsCombined.find(m => m.marketId == oddId);
              flatHeaders.push({
                oddId: oddId,
                oddName: originalOdd ? originalOdd.marketName : '[unknown market]',
                outcomeId: outcomeId,
                outcomeName: positionAndOutcomeName.n,
                index: positionAndOutcomeName.i,
              });
            });

            flatHeaders = flatHeaders.sort((x, y) => x.index - y.index);

            // split array into pages based on maxOutcomesPerPage
            const pages = chunkArray(flatHeaders, this.maxOutcomesPerPage);
            const matches = this.tournamentData.matches;
            const pagesData = pages.map((page) => {
              // get market names and column span per page
              const mappedMarketNames = page.reduce((prev, next) => {
                if (!prev[next.oddId]) {
                  prev[next.oddId] = {
                    name: next.oddName,
                    index: next.index,
                    colSpan: 1
                  };
                } else {
                  prev[next.oddId].colSpan += 1;
                }
                return prev;
              }, {});
              // convert marketNames to array and sort it by index
              const marketNames = Object.values(mappedMarketNames).sort((x, y) => x.index - y.index);
              // map outcomes from response to each match per page
              const matchesWithOutcomes = matches.map(match => {
                const matchInResponse = matchOutcomes[match.matchId];
                // map outcomes from api to columns in page
                const matchOdds = page.map(c => matchInResponse[`${c.oddId}_${c.outcomeId}`] || '--');
                return {
                  ...match,
                  matchOdds
                };
              });
              return {
                page,
                marketNames,
                matchesWithOutcomes,
              };
            });

            // create vue instance to print
            const categoryPrintPage = Vue.extend(CategoryPrintPage);
            const categoryPrintPageComp = new categoryPrintPage({
              propsData: {
                maxOutcomesPerPage: this.maxOutcomesPerPage,
                sportName: this.sportName,
                tournamentName: this.tournamentData.tournamentName,
                logo: this.logo,
                pages: pagesData,
              },
            });
            // return vue component
            resolve(categoryPrintPageComp);
          }, reject);
        });
      },
    },
  };
</script>

<style scoped>
  .loading-cursor {
    cursor: wait !important;
  }
</style>
